import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import CheckboxElement from "../UiComponents/CheckboxElement";
import ButtonElement from "../UiComponents/ButtonElement";
import { Link, useNavigate } from "react-router-dom";
import { updateGDPR } from "../../Services/userService";
import { getUser } from "../../Services/authService";
import { getCustomer } from "../../Services/customerServices";
import { get } from "../../Services/customerServices";

const AcceptGdpr = () => {
    const [acceptGdprDialog, setAcceptGdprDialog] = useState(true);
    const [isChecked, setIsChecked] = useState(false);
    const [customerShort, setCustomerShort] = useState('');

    const navigate = useNavigate();

    var enduser = localStorage.getItem("enduser")
	if (enduser) {
		var tmpData = JSON.parse(enduser);
		if (tmpData === null) {
            navigate("/login")
            localStorage.clear()
        }
	}

    useEffect(() => {
        getCustomerDetails();
    }, []);

    const getCustomerDetails = async () => {
        var customerData = await get(tmpData.customer)
        setCustomerShort(customerData.data.customer_short)
    }

    const currVersion = "";
    const versions = [];
    const loadPage = async function (currCustomer, currentPage) {
        const customerData = await getCustomer(currCustomer);
        if (customerData.data.version_maintained.length == 1) {
            currVersion = "v1";
        } else {
            for (var i = 0; i < customerData.data.version_maintained.length; i++) {
                if (customerData.data.version_maintained[i].module_name.toLowerCase() == "dashboard") {
                    versions.push(customerData.data.version_maintained[i].version_detail);
                }
            }
            if (currentPage == 'Opportunity') {
                navigate("/portfolio");
            } else if (currentPage == 'Dashboard') {
                navigate(`/dashboard/${customerShort}`);
            } else if (currentPage == 'Business Plan') {
                navigate(`/businessPlan/${customerShort}`);
            } else if (currentPage == 'Target Plan') {
                navigate(`/targetPlan/${customerShort}`);
            } else if (currentPage == 'Benchmarking') {
                navigate(`/benchmarking/${customerShort}`);
            } else if (currentPage == 'mfa') {
                navigate("/mfa");
            }
        }
    };

    const accpetGDPR = async () => {
        var userGdpr = await updateGDPR(tmpData.userid)
        if (userGdpr.data) {
            if (userGdpr.data.success) {
                var userDetails = await getUser()
                if (userDetails.data) {
                    localStorage.setItem("enduser", JSON.stringify(userDetails.data));
                    if (userDetails.data.isRestricted)
                        loadPage(userDetails.data.customer, 'Opportunity')
                    else
                        loadPage(userDetails.data.customer, 'Dashboard')
                }
            }
        }
    }

    const acceptGdprDialogFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement type="submit" label="Accept" className="save-button" onClick={accpetGDPR} disabled={!isChecked} />
                </div>
            </div>
        );
    }

    return (
        <div className="mfa-container">
            <Dialog visible={acceptGdprDialog} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Policy Update" modal footer={acceptGdprDialogFooter()} closable={false} className="table-dialog width-32" draggable={false}>
                <div className="confirmation-content">
                    <label className="form-label text-left">Hi &nbsp;</label>
                    <label className="form-label text-left font-bold">{tmpData.firstname + " " + tmpData.surname}</label>,
                </div>
                <div className="confirmation-content">
                    <label className="form-label text-left">A change in our&nbsp; <Link to={"/securityPolicies"}>Privacy Policy</Link> had taken effect since May 25,2018.</label>
                </div>
                <div className="confirmation-content">
                    <label className="form-label text-left">Please read carefully and accept.Thanks for using myConsole.</label>
                </div>
                <div className="confirmation-content">
                    <CheckboxElement
                        checked={isChecked}
                        onChangeCheck={(e) => setIsChecked(e.checked)}
                        className="mr-2"
                        value="I have read and accepted the Privacy Policy"
                    />
                </div>
            </Dialog>
        </div>
    )
}

export default AcceptGdpr